import React from "react";
import { render } from "react-dom";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import { Router, hashHistory } from "react-router";
import { syncHistoryWithStore, routerMiddleware } from "react-router-redux";
import reducers from "./reducers";
import { persistStore, autoRehydrate } from "redux-persist";
import asteroid from "./common/asteroid";
import ReactGA from "react-ga";

const middleware = routerMiddleware(hashHistory);
const store = createStore(
  reducers,
  applyMiddleware(middleware),
  autoRehydrate()
);

if (window.location.hostname === ("e24.unityducruet.com" || "localhost")) {
  ReactGA.initialize("UA-156176039-1"); //UA-154749682-1
  ReactGA.pageview("/inicio");
}

const authenticate = (nextState, replace) => {
  console.log(asteroid.loggedIn);
  if (!asteroid.loggedIn) {
    console.log("notloggedin");
    replace({
      pathname: "/",
      state: { nextPathname: nextState.location.pathname },
    });
  } else {
    return;
  }
};

persistStore(store, { blacklist: ["routing"] });

const history = syncHistoryWithStore(hashHistory, store);

function scrollToTop() {
  window.scrollTo(0, 0);
}

const rootRoute = {
  path: "/",

  indexRoute: { onEnter: (nextState, replace) => replace("/inicio") },
  component: require("./containers/App"),
  childRoutes: [
    {
      childRoutes: [
        require("./routes/app"),
        require("./routes/404"),
        require("./routes/inicio"),
      ],
    },
    {
      path: "*",
      indexRoute: { onEnter: (nextState, replace) => replace("/") },
    },
  ],
};

render(
  <Provider store={store}>
    <Router onUpdate={scrollToTop} history={history} routes={rootRoute} />
  </Provider>,
  document.getElementById("app-container")
);



// WEBPACK FOOTER //
// ./client.js